<template>
<div>
<el-dialog  title="调整库存" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible="kctzFlag" width="1250px" center append-to-body>
  <div>
    <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="100px" size="mini">
      <el-table height="90px" size="mini" border center bordersize="mini"  :data="[rowData]">
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" width="120" align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重(吨)" align="center">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="stockPoundWeight" label="过磅净重（吨）" width="120"
          align="center"></el-table-column>
      </el-table>
      <div style="margin-top:20px">
        <el-form-item label="调整方式:" prop="flag" class="jiage" >
            <el-radio-group v-model="goodform.flag">
              <el-radio :label="0">增加</el-radio>
              <el-radio :label="1">减少</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="调整量:" prop="allWeight"  >
          <el-input  placeholder=""  v-number-input.float="3"  maxlength="50"  v-model="goodform.allWeight" ></el-input>
        </el-form-item>
        <el-form-item label="仓位:" prop="stockWarehouseId"  >
          <el-select clearable filterable v-model="goodform.stockWarehouseId" size="mini" >
                <el-option v-for="(item,index) in cwList" :key="index" :label="item.warehouseName" :value="item.stockWarehouseId"></el-option>
              </el-select>
        </el-form-item>
      </div>
    </el-form>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="closeDialog">取 消</el-button>
    <el-button type="primary" @click="saveFn()">提交</el-button>
  </span>
</el-dialog>
</div>
</template>

<script>
import { JfgetEmptyBillStockWarehouseInfo, inventoryAdjustment, getWeighingMethodList } from '@/api/wms-stock'
import { emptyFn } from '@/utils/util'
export default {
  name: 'zhipaiyouhuo',
  props: {
    kctzFlag: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      goodform: {},
      rules: {
        flag: [
          { required: true, message: '请选择调整方式', trigger: 'blur' }
        ],
        allWeight: [
          { required: true, message: '请输入调整量', trigger: 'blur' }
        ],
        stockWarehouseId: [
          { required: true, message: '请选择仓位', trigger: 'blur' }
        ]
      },
      cwList: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    JfgetEmptyBillStockWarehouseInfo({
      primaryCustomerTaxId: this.rowData.primaryCustomerTaxId, // （一级货主id  必填）
      customerTaxId: this.rowData.customerTaxId, // （二级货主id 必填）
      productType: this.rowData.productType, // （货物类型id  非必填）
      steelMillName: this.rowData.steelMillName, // （产地  非必填）
      model: this.rowData.model, // （材质 非必填）
      specification: this.rowData.specification // （规格  非必填）
    }).then(res => {
      this.cwList = res.tEmptyStockWarehouseList
    }).catch(err => {
      this.$message.error(err.message)
    })
    this.goodform.stockCustomerId = this.rowData.stockCustomerId
  },
  methods: {
    saveFn () {
      this.$refs.goodform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          inventoryAdjustment(this.goodform).then(res => {
            loading.close()
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.addFlag = false
            this.$emit('update:kctzFlag', false)
            this.$parent.chaxun()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    closeDialog () {
      this.$emit('update:kctzFlag', false)
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>

</style>
